export * from './switcher.component';